export default "__VITE_ASSET__e8f13b6b__"